import { ChangeDetectorRef, Component } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
  constructor(
    protected spinnerService: SpinnerService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges(); // força a detecção de mudanças após renderização
  }
}
